import { convertFromHTML } from "draft-convert";

export const getStateFromHtml = convertFromHTML({
  htmlToEntity: (nodeName, node, createEntity) => {
    if (nodeName === "a" && node.dataset.userId) {
      return createEntity("USER_MENTION", "IMMUTABLE", {
        userId: node.dataset.userId,
      });
    }
    return undefined;
  },
});
